module.exports = __webpack_public_path__ + "img/site_22_pb.da903621.png";